export const DEFAULT_COORDINATES = { lat: 50.1, lng: 14.4 }

export const COUNTRY_COORDINATES: Record<string, { lat: number; lng: number }> = {
  US: { lat: 39.8, lng: -98.6 },
  GB: { lat: 54.0, lng: -2.0 },
  DE: { lat: 51.2, lng: 10.4 },
  FR: { lat: 46.2, lng: 2.2 },
  PL: { lat: 52.0, lng: 19.0 },
  LV: { lat: 56.9, lng: 24.1 },
  LT: { lat: 55.2, lng: 23.9 },
  EE: { lat: 58.6, lng: 25.0 },
  ES: { lat: 40.5, lng: -3.7 },
  IT: { lat: 41.9, lng: 12.6 },
  NL: { lat: 52.1, lng: 5.3 },
  BE: { lat: 50.5, lng: 4.5 },
  AT: { lat: 47.5, lng: 14.6 },
  CH: { lat: 46.8, lng: 8.2 },
  CZ: { lat: 49.8, lng: 15.5 },
  SE: { lat: 60.1, lng: 18.6 },
  NO: { lat: 60.5, lng: 8.5 },
  DK: { lat: 56.3, lng: 9.5 },
  FI: { lat: 61.9, lng: 25.7 },
  PT: { lat: 39.4, lng: -8.2 },
  IE: { lat: 53.4, lng: -8.2 },
  GR: { lat: 39.1, lng: 21.8 },
  HU: { lat: 47.2, lng: 19.5 },
  RO: { lat: 45.9, lng: 24.97 },
  BG: { lat: 42.7, lng: 25.5 },
  HR: { lat: 45.1, lng: 15.2 },
  SK: { lat: 48.7, lng: 19.7 },
  SI: { lat: 46.15, lng: 14.99 },
  UA: { lat: 48.4, lng: 31.2 },
  RU: { lat: 61.5, lng: 105.3 },
  CA: { lat: 56.1, lng: -106.3 },
  AU: { lat: -25.3, lng: 133.8 },
  NZ: { lat: -40.9, lng: 174.9 },
  JP: { lat: 36.2, lng: 138.3 },
  KR: { lat: 35.9, lng: 127.8 },
  CN: { lat: 35.9, lng: 104.2 },
  IN: { lat: 20.6, lng: 79.0 },
  BR: { lat: -14.2, lng: -51.9 },
  MX: { lat: 23.6, lng: -102.6 },
  AR: { lat: -38.4, lng: -63.6 },
  ZA: { lat: -30.6, lng: 22.9 },
}
